export default "__VITE_ASSET__tRJNOt1YOVdI8OrEQYtO2A__"